/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { range } from 'lodash';
import { List } from 'immutable';
import Form from 'src/components/Form/Form';
import SportCompetitionsInput from 'src/components/SportCompetitionsInput';
import { DateTimeRange } from 'src/components/DatetimeRangeInput/DateTimeRange';
import RangeInput from 'src/components/RangeInput/RangeInput';
import UniverseAware from 'src/utils/UniverseAware';
import { BET_TYPES } from './config';
import { DateTime } from 'src_common/utils/time/time';

@UniverseAware
export class BetSearchForm extends Form {
    static propTypes = {
        ...Form.propTypes,
        sports: ImmutablePropTypes.list,
    };

    static defaultProps = {
        ...Form.defaultProps,
        sports: List(),
    };

    static fieldsValidation = {
        stakeFactor: [
            (value, data) => {
                if (!value) {
                    return null;
                }

                const getValid_start = Form.rules.maxPrecision(value.start, data, 3);
                return getValid_start === null ? Form.rules.maxPrecision(value.end, data, 3) : getValid_start;
            },
        ],
    };

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const { sports, errors, isFetchingCompSports, universePrefix } = this.props;

        const leftColumn = (
            <>
                {this.getField(
                    <select
                        label='Type'
                        {...this.getFieldParameters('type')}
                    >
                        <option />
                        <option value='placement'>Placement</option>
                        <option value='settlement'>Settlement</option>
                    </select>
                )}
                {this.getField(
                    <DateTimeRange
                        data-test='range'
                        {...this.getFieldParameters('range')}
                        maxDate={DateTime.current().toISOString()}
                        dateFormat='yyyy-MM-dd'
                        timeFormat='HH:mm:ss'
                    />
                )}
                <div className='form-prefix-group'>
                    {universePrefix ? <span className='form-prefix-group__label'>{universePrefix}</span> : void 0}
                    {this.getField(
                        <input
                            type='text'
                            label='Account ID'
                            {...this.getFieldParameters('accountId')}
                        />
                    )}
                </div>
                <div className='row'>
                    {this.getField(
                        <select
                            label='Search by'
                            {...this.getFieldParameters('searchBy')}
                        >
                            <option value='empty' />
                            <option value='betId'>Bet ID</option>
                            <option value='eventId'>Event ID</option>
                        </select>
                    )}
                    {this.state.data['searchBy'] !== 'empty' &&
                        this.getField(
                            <input
                                type='text'
                                label={this.state.data['searchBy'] === 'betId' ? 'Bet Id' : 'Event Id'}
                                {...this.getFieldParameters('searchByIdValue')}
                            />
                        )}
                </div>
                {this.getField(
                    <RangeInput
                        label='Stake factor'
                        {...this.getFieldParameters('stakeFactor')}
                    />
                )}
                {this.getField(
                    <RangeInput
                        label='Total stake'
                        prefix='£'
                        {...this.getFieldParameters('totalStake')}
                    />
                )}
                {this.getField(
                    <RangeInput
                        label='Payout amount'
                        prefix='£'
                        {...this.getFieldParameters('payoutAmount')}
                    />
                )}

                <div className='checkboxes-group'>
                    <h4>Status</h4>

                    {this.getCheckbox('status[open]', 'Open')}
                    {this.getCheckbox('status[parked]', 'Parked')}
                    {this.getCheckbox('status[settled]', 'Settled')}
                    {this.getCheckbox('status[cancelled]', 'Cancelled')}
                </div>
                {this.getField(
                    <select
                        label='Cashed out'
                        {...this.getFieldParameters('cashedOut')}
                    >
                        <option value='both'>Both</option>
                        <option value='yes'>Yes</option>
                        <option value='no'>No</option>
                    </select>
                )}
                {this.getField(
                    <select
                        label='Settle Type'
                        {...this.getFieldParameters('settleType')}
                    >
                        <option value=' '>Any</option>
                        <option value='selection'>Automatic</option>
                        <option value='manual'>Manual</option>
                    </select>
                )}
                <div className='checkboxes-group'>
                    <h4>Channel</h4>

                    {this.getCheckbox('channel[desktop]', 'Desktop')}
                    {this.getCheckbox('channel[mobile,quickbet]', 'Mobile')}
                    {this.getCheckbox('channel[telebetting]', 'Telebet')}
                    {this.getCheckbox('channel[on-course]', 'On course')}
                </div>
                <div className='row'>
                    <div className='col-9'>
                        {this.getField(
                            <select
                                label='In play'
                                {...this.getFieldParameters('inPlay')}
                            >
                                <option value='both'>Both</option>
                                <option value='yes'>Yes</option>
                                <option value='no'>No</option>
                            </select>
                        )}
                    </div>
                    <div className='col-3'>{this.getCheckbox('freebet', 'Show Freebets Only')}</div>
                    <div className='col-3'>
                        {this.getCheckbox('startingPrice', 'Show SP column <br>(for SP and BP bets)')}
                    </div>
                </div>
            </>
        );

        const rightColumn = (
            <>
                <div className='checkboxes-group'>
                    <h4>Bet types</h4>

                    <div className='checkboxes-group-list'>
                        {BET_TYPES.map((type) => this.getCheckbox(`betType[${type.id}]`, type.name, type.id))}
                    </div>
                </div>

                {this.getField(
                    <SportCompetitionsInput
                        disallowEmpty={false}
                        sortAlphabetically={true}
                        isLoading={isFetchingCompSports}
                        sports={sports}
                        {...this.getFieldParameters('sport')}
                    />
                )}

                {this.getBasicError(errors.get && errors.get('program'))}

                <div className='row'>
                    <div className='col-6'>{this.getCheckbox('summary', 'Include summary')}</div>
                    <div className='col-6'>
                        <div className='buttons'>
                            <button
                                className='btn btn-primary'
                                type='submit'
                                data-test='search-button'
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );

        return (
            <div className='bet-search-form'>
                <div className='row'>
                    <div className='col-6'>{leftColumn}</div>
                    <div className='col-6'>{rightColumn}</div>
                </div>
            </div>
        );
    }
}
